module.exports = __webpack_public_path__ + "media/30th_anniversary_sweepstakes/submit-green-7f80a62d.svg";